var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6843 32.7122C11.6843 44.656 21.4885 54.4602 33.4322 54.4602C45.376 54.4602 55.1801 44.656 55.1801 32.7122C55.1801 20.7685 45.376 10.9643 33.4322 10.9643C21.4885 10.9643 11.6843 20.7685 11.6843 32.7122ZM6.34888 32.7122C6.34888 17.7081 18.428 5.62891 33.4322 5.62891C48.4364 5.62891 60.5155 17.7081 60.5155 32.7122C60.5155 47.7164 48.4364 59.7956 33.4322 59.7956C18.428 59.7956 6.34888 47.7164 6.34888 32.7122ZM29.2614 30.0039V21.8789L18.5364 32.7122L29.2614 43.5456V35.4206H48.328V30.0039",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.0b7992b447376681076212ee28cb2972.svg";
export { ForwardRef as ReactComponent };